const STORAGE_KEY = "mhome.pampas.cn.login-intent.v1";
const INTENT_TTL_MILLIS = 10 * 60 * 1000;

export function readCnLoginIntent() {
  try {
    const intent = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "null");
    if (
      !intent ||
      !intent.relayId ||
      !["callback", "pairing"].includes(intent.flow) ||
      Number(intent.createdAt) + INTENT_TTL_MILLIS <= Date.now()
    ) {
      clearCnLoginIntent();
      return null;
    }
    return intent;
  } catch (_) {
    clearCnLoginIntent();
    return null;
  }
}

export function saveCnLoginIntent(intent) {
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ ...intent, createdAt: Date.now() })
  );
}

export function clearCnLoginIntent() {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function captureCnLoginIntent() {
  const query = new URLSearchParams(window.location.search);
  const flow = query.get("flow");
  const relayId = query.get("id");
  if (!relayId || !["callback", "pairing"].includes(flow)) return null;

  const previous = readCnLoginIntent();
  let loginTicket = "";
  if (flow === "callback") {
    loginTicket =
      new URLSearchParams(window.location.hash.slice(1)).get("ticket") || "";
    if (
      !loginTicket &&
      previous?.flow === flow &&
      previous.relayId === relayId
    ) {
      loginTicket = previous.loginTicket || "";
    }
    if (!loginTicket) return null;
  }

  const intent = { flow, relayId, loginTicket };
  saveCnLoginIntent(intent);
  if (window.location.hash) {
    window.history.replaceState(
      null,
      "",
      `${window.location.pathname}${window.location.search}`
    );
  }
  return readCnLoginIntent();
}
